import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SectionTitle, Text } from "../../components/styledComponent";
// import connectPointerOne from "../../assets/connectPointerOne.png";
// import connectPointerTwo from "../../assets/connectPointerTwo.png";
// import connectPointerThree from "../../assets/connectPointerThree.png";
// import connectPointerFour from "../../assets/connectPointerFour.png";
import benefitOne from "../../assets/benefitOne.png";
import benefitTwo from "../../assets/benefitTwo.png";
import benefitThree from "../../assets/benefitThree.png";
import benefitFour from "../../assets/benefitFour.png";
import connectCard from "../../assets/connectCard.webp";
import styles from "./style.module.scss";
import { routes } from "../../utils/routes";
import { Anchor, Button } from "../../components/styledComponent";
import fleetPdf from "../../assets/fleetpdf.pdf";

const CancoConnect = () => {
  return (
    <div className={styles.cancoConnectPage}>
      {/* Banner section */}
      <div className={styles.bannerSection}></div>

      {/* Canco connect cardlock */}
      {/* <Container className={`sectionContainer ${styles.aboutConnectSection}`}>
        <Row className={styles.aboutConnectInfo}>
          <Col>
            <SectionTitle>A Cardlock that works for you</SectionTitle>
            <div className={styles.pointerSection}>
              <div className={styles.pointerInfo}>
                <img src={connectPointerOne} alt="Pointer" />
                <Text>No annual fee</Text>
              </div>
              <div className={styles.pointerInfo}>
                <img src={connectPointerTwo} alt="Pointer" />
                <Text>Marked Fuels</Text>
              </div>
              <div className={styles.pointerInfo}>
                <img src={connectPointerThree} alt="Pointer" />
                <Text>Access 24 hours a day</Text>
              </div>
              <div className={styles.pointerInfo}>
                <img src={connectPointerFour} alt="Pointer" />
                <Text>Tiered volume discounts</Text>
              </div>
            </div>
            <div className={styles.cardImg}>
              <img src={connectCard} alt="canco connect cardlock" />
            </div>
          </Col>
        </Row>
      </Container> */}

      {/* Benefits of fleet card */}
      <Container className={`sectionContainer ${styles.benefitsFleetCard}`}>
        {/* <Row className={styles.benefitsTitle}>
          <Col>
            <SectionTitle>A Cardlock that works for you!</SectionTitle>
          </Col>
        </Row> */}
        <Row className={styles.benefitsContent}>
          <Col xs={12} md={12} lg={6} className={styles.benefitInfo}>
            <SectionTitle>Benefits</SectionTitle>
            <div className={styles.benefitBlock}>
              <div>
                <img src={benefitOne} alt="benefit" />
              </div>
              <div>
                <ul>
                  <li>Annual Fee: $0</li>
                  <li>Tiered Volume Discounts</li>
                  {/* <li>5% Discount on Automotive Purchases</li> */}
                </ul>
              </div>
            </div>
            <div className={styles.benefitBlock}>
              <div>
                <img src={benefitTwo} alt="benefit" />
              </div>
              <div>
                <ul>
                  <li>Dedicated Customer Service</li>
                  <li>Pin Protected</li>
                  <li>Spending Control</li>
                </ul>
              </div>
            </div>
            <div className={styles.benefitBlock}>
              <div>
                <img src={benefitThree} alt="benefit" />
              </div>
              <div>
                <ul>
                  <li>Easy to Manage</li>
                  <li>Detailed Card Reporting</li>
                </ul>
              </div>
            </div>
            <div className={styles.benefitBlock}>
              <div>
                <img src={benefitFour} alt="benefit" />
              </div>
              <div>
                <ul>
                  <li>
                    High quality fuel purchased from same terminals as major
                    national brands
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <img src={connectCard} alt="Cardlock card" />
          </Col>
        </Row>
      </Container>

      {/* Apply Today */}
      <div className={styles.applyTodaySection}>
        <Container className={`sectionContainer`}>
          <Row>
            <Col xs={12} md={12} lg={6}>
              <div>
                <SectionTitle>Online Application</SectionTitle>
                <div className={styles.applySteps}>
                  <div className={styles.stepInfo}>
                    {/* <h3>1</h3> */}
                    <Text>
                      Apply for a Canco Connect Cardlock account now and take
                      control of your fleet’s fuel expenses. Click on the button
                      below to begin your online application.
                    </Text>
                  </div>
                  {/* <div className={styles.stepInfo}>
                  <h3>2</h3>
                  <Text>Send Application and Void Cheque</Text>
                </div>
                <div className={styles.stepInfo}>
                  <h3>3</h3>
                  <Text>
                    Send by email to{" "}
                    <a href="xpress@cancopetroleum.ca">
                      xpress@cancopetroleum.ca
                    </a>
                  </Text>
                </div> */}
                </div>
              </div>
              <Anchor href={routes.APPLY_CANCO_CONNECT}>
                START APPLICATION
              </Anchor>
            </Col>
            <Col xs={12} md={12} lg={6}>
              <div>
                <SectionTitle>Printed Version</SectionTitle>
                <div className={styles.applySteps}>
                  <div className={styles.stepInfo}>
                    {/* <h3>1</h3> */}
                    <Text>
                      If you wish to send in your application by Email or Mail,
                      please print off the application by clicking below.
                    </Text>
                  </div>
                  {/* <div className={styles.stepInfo}>
                  <h3>2</h3>
                  <Text>Send Application and Void Cheque</Text>
                </div>
                <div className={styles.stepInfo}>
                  <h3>3</h3>
                  <Text>
                    Send by email to{" "}
                    <a href="xpress@cancopetroleum.ca">
                      xpress@cancopetroleum.ca
                    </a>
                  </Text>
                </div> */}
                </div>
              </div>
              <Button onClick={() => window.open(fleetPdf, "_blank")}>
                PRINT APPLICATION
              </Button>
            </Col>
            {/* <Col xs={12} md={12} lg={6}>
              <h5>
                If you wish to send in your application by Email or Mail, please
                follow the steps below:
              </h5>
              <ul>
                <li>
                  Please{" "}
                  <button
                    onClick={() => window.open(fleetPdf, "_blank")}
                    style={{ color: "#c9a745" }}
                  >
                    click here
                  </button>{" "}
                  to download the PDF version of the application
                </li>
                <li>Include a void cheque when sending in your application</li>
                <li>
                  Mail to the Canco Petroleum Head Office located at 200 - 125,
                  Hwy 33 E, Kelowna, BC V1X 2A1
                </li>
              </ul>
              <Text style={{ marginBottom: "10px" }}>OR</Text>
              <ul>
                <li>
                  Please scan the completed application and the void cheque,
                  then attach them in an email addressed to{" "}
                  <a href="mailto:xpress@cancopetroleum.ca">
                    xpress@cancopetroleum.ca
                  </a>
                </li>
              </ul>
              <Text>
                For questions or concerns, please send us an email
                <br />
                <a href="mailto:xpress@cancopetroleum.ca">
                  xpress@cancopetroleum.ca
                </a>
              </Text>
            </Col> */}
          </Row>
        </Container>
      </div>

      <Text $textAlign="center" className={styles.applicationSendInfo}>
        For questions or concerns, please send us an email
        <br />
        <a href="mailto:cardlock@cancopetroleum.ca">
          cardlock@cancopetroleum.ca
        </a>
      </Text>
    </div>
  );
};

export default CancoConnect;
